import { findIndex } from 'lodash';
import TreatmentAreasDB from 'src/fb/treatmentAreas-db';
import { auth as useAuthStore } from 'src/store/auth';

export default {

  async loadClinicTreatmentAreas() {
    const auth = useAuthStore();

    if (!auth.connectedClinic?.id) {
      return;
    }

    const treatmentAreasDb = new TreatmentAreasDB(auth.connectedClinic.id);

    this.clinicTreatmentAreas = await treatmentAreasDb.readAll();
  }, // loadClinicTreatmentAreas()

  async addNewTreatmentArea(treatmentAreaData) {
    const auth = useAuthStore();

    const treatmentAreasDb = new TreatmentAreasDB(auth.connectedClinic.id);

    const newTreatmentArea = await treatmentAreasDb.create({
      createdBy: auth.userDetails.userId,
      ...treatmentAreaData,
    });

    this.clinicTreatmentAreas.push(newTreatmentArea);

    return newTreatmentArea;
  }, // addNewTreatmentArea()

  async editTreatmentArea(treatmentAreaData) {
    const auth = useAuthStore();

    const treatmentAreasDb = new TreatmentAreasDB(auth.connectedClinic.id);

    await treatmentAreasDb.update(treatmentAreaData);

    const treatmentAreaIdx = findIndex(this.clinicTreatmentAreas, { id: treatmentAreaData.id });

    this.clinicTreatmentAreas.splice(treatmentAreaIdx, 1, treatmentAreaData);
  }, // editTreatmentArea()

  async removeTreatmentArea(treatmentAreaId) {
    const auth = useAuthStore();

    const treatmentAreasDb = new TreatmentAreasDB(auth.connectedClinic.id);

    await treatmentAreasDb.delete(treatmentAreaId);

    const treatmentAreaIdx = findIndex(this.clinicTreatmentAreas, { id: treatmentAreaId });

    this.clinicTreatmentAreas.splice(treatmentAreaIdx, 1);
  }, // removeTreatmentArea()

  async login() {
    await this.loadClinicTreatmentAreas();
  }, // login()

};
